module.exports = "<svg height=\"11\" width=\"11\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\"><path fill-rule=\"evenodd\" d=\"M10.76 3.89V.24L9.4 1.6C8.4.6 7.03-.02 5.51-.02 2.47-.02 0 2.45 0 5.49 0 8.53 2.47 11 5.51 11a5.51 5.51 0 0 0 4.78-2.78l-1.13-.64A4.203 4.203 0 0 1 5.51 9.7C3.19 9.7 1.3 7.81 1.3 5.49c0-2.32 1.89-4.21 4.21-4.21 1.16 0 2.21.47 2.97 1.24L7.11 3.89h3.65zm0 0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/rotate.svg
// module id = 887
// module chunks = 0